import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const Results = ({ matchDataRecord}) => {
    const kdParts = (matchDataRecord.kd || '').split('<br>');
    const { t } = useTranslation();
    
const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px',
    background: '#fff',
    marginTop: '24px',
};

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'left',
};


const tdTdStyle = {
    border: '1px solid #ccc',
    padding: '0px 4px',
    textAlign: 'left',
};
    return (
        <table style={tableStyle}>
            <tbody>
                <tr>
                    <th style={thTdStyle}>
                        {t("DASA") + ' ' + t('PORONDAMA')}
                    </th>
                    <th style={thTdStyle}>
                        {t("Visi") + ' ' + t('PORONDAMA')}
                    </th>
                    <th style={thTdStyle}>
                        {t("KD")}
                    </th>
                    
                </tr>
                <tr>
                    <td style={tdTdStyle}>
                        {t('Shuba') + ' ' + matchDataRecord.dps + ' (' + matchDataRecord.dp + '%)'}
                    </td>
                    <td style={tdTdStyle}>
                        {t('Shuba') + ' ' + matchDataRecord.vps + ' (' + (matchDataRecord.vp / 2) + '%)'}
                    </td>
                    <td style={tdTdStyle}>
                        {kdParts[0] || ''} {kdParts[1] ? <br /> : ''} {kdParts[1] || ''}
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

Results.propTypes = {
    matchDataRecord: PropTypes.shape({
        dps: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        vps: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        vp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        kd: PropTypes.string,
    }).isRequired,
    t: PropTypes.func.isRequired,
};

export default Results;
